/** @file Set bearer token on outgoing axios calls, check responses for 401s */

import axios from 'axios';
import Logger from '../util/logger';
import { getAccessTokenWithAudience } from '../util/auth0Utils';

// Auth0 functions will be injected via the context
let getAccessTokenSilently: ((options?: any) => Promise<string>) | null = null;

export const setAuth0Functions = (getTokenFn: (options?: any) => Promise<string>) => {
  getAccessTokenSilently = getTokenFn;
};

export default () => {
  // Apply JWT to all outgoing requests
  axios.interceptors.request.use(
    async (config) => {
      try {
        if (!getAccessTokenSilently) {
          Logger.warn('Auth0 getAccessTokenSilently function not available');
          return config;
        }

        // Always get fresh token from Auth0 - it handles caching internally
        const token = await getAccessTokenWithAudience(getAccessTokenSilently);

        if (token) {
          // TODO: remove eslint-disable and address
          // eslint-disable-next-line no-param-reassign
          config!.headers!.Authorization = `Bearer ${token}`;
        }
      } catch (error: any) {
        Logger.error('Error getting access token:', error);

        // getAccessTokenWithAudience handles logout for token API failures
        // For other errors, let the request proceed without auth
        Logger.warn('Proceeding with request without authorization token due to Auth0 error');
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      // Return any error which is not due to authentication or bad auth is okay
      if (error.response?.status === 403 || error.response?.status === 401) {
        // auth0Utils handles token cleanup and logout for authentication errors
        Logger.warn('Authentication error - clearing application data');
      }
      return Promise.reject(error);
    },
  );
};
